import { jsx as _jsx } from "react/jsx-runtime";
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Result } from 'antd';
import React, { Suspense } from 'react';
import { AccountAPI } from 'api/account';
import { PageLoading } from 'components/atoms/loading';
import { Button } from 'components/facade/button';
import { MagicLinkGeneratePage } from 'components/molecules/session-setup';
import { TokenErrorStatus } from 'components/organisms/token-error/constant';
import { RoutePaths } from 'constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { useQueryParams } from 'hooks/use-query-params';
import { useTranslation } from 'hooks/use-translation';
import { useAccountMetaQuery } from 'queries';
import { TokenType } from 'services';
import { getDecodedEmail, getTokenMeta, isLinkMagicDecoded, isResendableLinkMagic } from 'utils/token';
const TokenError = /*#__PURE__*/ React.lazy(()=>import('components/organisms/token-error/token-error').then((d)=>({
            default: d.TokenError
        })));
export const SessionError = ()=>{
    return /*#__PURE__*/ _jsx(Result, {
        status: "error",
        title: useTranslation('session.error.title'),
        subTitle: useTranslation('session.error.message'),
        extra: [
            /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                href: RoutePaths.newMagicLink,
                icon: /*#__PURE__*/ _jsx(ArrowRight16, {}),
                iconPlacement: "right",
                children: useTranslation('magic_link.new')
            }, "new-magic-link")
        ]
    });
};
export const MagicLinkPage = ()=>{
    var _params_get, _params_get1, _ref;
    var _data_okta;
    const params = useQueryParams();
    const token = (_params_get = params.get('token')) !== null && _params_get !== void 0 ? _params_get : '';
    // In some cases customer will generate the token and pass it via url
    const extToken = (_params_get1 = params.get('rl-token')) !== null && _params_get1 !== void 0 ? _params_get1 : '';
    const tokenType = extToken ? TokenType.External : TokenType.Rocketlane;
    const [isLoading, isError] = useLoginWithToken(token || extToken || '', tokenType);
    const { data } = useAccountMetaQuery();
    const cookiesEnabled = (_ref = data === null || data === void 0 ? void 0 : (_data_okta = data.okta) === null || _data_okta === void 0 ? void 0 : _data_okta.cookiesEnabled) !== null && _ref !== void 0 ? _ref : false;
    const { decoded, isExpired } = getTokenMeta(token);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(PageLoading, {});
    }
    if (isError) {
        // Expired resendable cookies LINK_MAGIC → standard Expired page + resendMagicLink (like
        // /login). cookiesEnabled gate matches useLoginWithToken; everything else → the manual form.
        if (cookiesEnabled && isExpired && decoded && isResendableLinkMagic(decoded)) {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
                children: /*#__PURE__*/ _jsx(TokenError, {
                    status: TokenErrorStatus.Expired,
                    email: getDecodedEmail(decoded),
                    resendEmail: ()=>AccountAPI.resendMagicLink(token),
                    linkType: isLinkMagicDecoded(decoded) ? decoded.link_type : undefined
                })
            });
        }
        return /*#__PURE__*/ _jsx(MagicLinkGeneratePage, {});
    }
    return null;
};
